import { Component, Vue } from 'vue-property-decorator';
import { sessionService } from '@/providers/services/auth/session';

@Component
export default class Console extends Vue {

    // -----------------------------------------------------------------
    // Properties

    /**
     * Having session properties
     */
    private get session() {
        return sessionService.getSession();
    }

    // ------------------------------------------------------------------
    // Actions

    /**
     * Action trigger when we click on xAPI
     * @param name
     */
    private onSelectTab(name: string) {
        this.$router.push(`/console/${name}`);
    }

    /**
     * Action trigger when we click on impersonate API
     */
    private routeToImpersonate() {
        this.$router.push('/console/impersonate/users');
    }

}
